/*
  Norvela — kleurbundel.

  Het gewone bundelblok zet alleen het aantal omhoog en levert dus drie keer
  dezelfde variant. Hier kiest de klant per doek een uitvoering, en leggen we
  alles in één keer in de winkelwagen.

  De korting zelf komt van een automatische kortingsregel in Shopify op het
  aantal artikelen van dit product. Die telt over varianten heen, dus een roze
  plus een zwarte telt gewoon als twee.
*/
(function () {
  'use strict';

  function lees(blok) {
    /* Shopify hijst dit JSON-blokje soms buiten het blok, dus eerst binnenin
       zoeken en anders in de hele pagina. */
    var el =
      blok.querySelector('[data-nv-kb-prijzen]') ||
      document.querySelector('[data-nv-kb-prijzen]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function bedrag(centen, formaat) {
    var euro = (centen / 100).toFixed(2).replace('.', ',');
    if (formaat && formaat.indexOf('{{') !== -1) {
      return formaat.replace(/\{\{\s*[a-z_]+\s*\}\}/, euro);
    }
    return '€' + euro;
  }

  function gekozenAantal(blok) {
    var knop = blok.querySelector('.nv-kb__optie.is-gekozen');
    return knop ? parseInt(knop.getAttribute('data-nv-kb-aantal'), 10) || 1 : 1;
  }

  function regels(blok) {
    return blok.querySelectorAll('[data-nv-kb-regel]');
  }

  /* Alleen zoveel keuzelijsten tonen als er doeken gekozen zijn. */
  function toonRegels(blok, aantal) {
    var rs = regels(blok);
    for (var i = 0; i < rs.length; i++) {
      rs[i].hidden = i >= aantal;
    }
  }

  function markeer(blok, aantal) {
    var knoppen = blok.querySelectorAll('.nv-kb__optie');
    for (var i = 0; i < knoppen.length; i++) {
      var raak = knoppen[i].getAttribute('data-nv-kb-aantal') === String(aantal);
      knoppen[i].classList.toggle('is-gekozen', raak);
      knoppen[i].setAttribute('aria-pressed', raak ? 'true' : 'false');
    }
  }

  /* De prijs volgt de eerste keuze. Alle uitvoeringen kosten hetzelfde, maar
     als dat ooit verandert klopt dit nog steeds. */
  function stukprijs(blok, data) {
    var eerste = blok.querySelector('[data-nv-kb-select]');
    if (eerste && data.varianten[eerste.value] !== undefined) {
      return data.varianten[eerste.value];
    }
    for (var id in data.varianten) return data.varianten[id];
    return 0;
  }

  function herreken(blok, data) {
    var prijs = stukprijs(blok, data);
    var knoppen = blok.querySelectorAll('.nv-kb__optie');

    for (var i = 0; i < knoppen.length; i++) {
      var knop = knoppen[i];
      var aantal = parseInt(knop.getAttribute('data-nv-kb-aantal'), 10) || 1;
      var korting = parseInt(knop.getAttribute('data-nv-kb-korting'), 10) || 0;

      /* Shopify rekent per stuk en rondt het kortingsbedrag naar beneden af,
         niet de prijs. Zo rekenen wij ook, anders wijkt de winkelwagen af. */
      var afPerStuk = Math.floor((prijs * korting) / 100);
      var perStuk = prijs - afPerStuk;
      var nieuw = perStuk * aantal;
      var oud = prijs * aantal;

      var elPer = knop.querySelector('[data-nv-kb-perstuk]');
      var elNieuw = knop.querySelector('[data-nv-kb-nieuw]');
      var elOud = knop.querySelector('[data-nv-kb-oud]');

      if (elPer) elPer.textContent = bedrag(perStuk, data.valuta_formaat) + ' per stuk';
      if (elNieuw) elNieuw.textContent = bedrag(nieuw, data.valuta_formaat);
      if (elOud) {
        if (oud > nieuw) {
          elOud.textContent = bedrag(oud, data.valuta_formaat);
          elOud.hidden = false;
        } else {
          elOud.hidden = true;
        }
      }
    }
  }

  function melding(blok, tekst, isFout) {
    var el = blok.querySelector('[data-nv-kb-melding]');
    if (!el) return;
    if (!tekst) {
      el.hidden = true;
      return;
    }
    el.textContent = tekst;
    el.style.color = isFout ? '#a3402f' : '';
    el.hidden = false;
  }

  function winkelwagenBijwerken() {
    /* Het thema luistert hierop en ververst de winkelwagenlade. */
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  }

  function toevoegen(blok, data) {
    var knop = blok.querySelector('[data-nv-kb-toevoegen]');
    var tekstEl = blok.querySelector('[data-nv-kb-knoptekst]');
    var origineel = tekstEl ? tekstEl.textContent : '';
    var aantal = gekozenAantal(blok);

    /* Dezelfde uitvoering meerdere keren? Dan één regel met een hoger aantal,
       anders maakt Shopify er alsnog één regel van en ziet het er rommelig uit. */
    var telling = {};
    var rs = regels(blok);
    for (var i = 0; i < aantal && i < rs.length; i++) {
      var sel = rs[i].querySelector('[data-nv-kb-select]');
      if (!sel || !sel.value) continue;
      telling[sel.value] = (telling[sel.value] || 0) + 1;
    }

    var items = [];
    for (var id in telling) items.push({ id: Number(id), quantity: telling[id] });
    if (!items.length) return;

    if (knop) knop.disabled = true;
    if (tekstEl) tekstEl.textContent = 'Bezig…';
    melding(blok, '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('winkelwagen');
        return r.json();
      })
      .then(function () {
        if (tekstEl) tekstEl.textContent = origineel;
        if (knop) knop.disabled = false;
        melding(blok, aantal === 1 ? 'Toegevoegd aan je winkelwagen.' : aantal + ' doeken toegevoegd aan je winkelwagen.');
        winkelwagenBijwerken();
      })
      .catch(function () {
        if (tekstEl) tekstEl.textContent = origineel;
        if (knop) knop.disabled = false;
        melding(blok, 'Dat lukte niet. Probeer het nog een keer.', true);
      });
  }
  function synchroniseer(blok) {
    var veld = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = veld && veld.value;
    if (!id) return;
    var eerste = blok.querySelector('[data-nv-kb-select]');
    if (!eerste || eerste.value === id) return;
    var bestaat = false;
    for (var i = 0; i < eerste.options.length; i++) {
      if (eerste.options[i].value === id) { bestaat = true; break; }
    }
    if (!bestaat) return;
    eerste.value = id;
    eerste.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function synchroniseerStraks(blok) {
    var pogingen = 0;
    var tik = setInterval(function () {
      synchroniseer(blok);
      if (++pogingen >= 8) clearInterval(tik);
    }, 150);
  }
  function koppel(blok) {
    if (blok.dataset.norvelaKbGekoppeld === 'ja') return;
    var data = lees(blok);
    if (!data || !data.varianten) return;
    blok.dataset.norvelaKbGekoppeld = 'ja';

    blok.addEventListener('click', function (e) {
      var optie = e.target.closest('.nv-kb__optie');
      if (optie) {
        var aantal = parseInt(optie.getAttribute('data-nv-kb-aantal'), 10) || 1;
        markeer(blok, aantal);
        toonRegels(blok, aantal);
        melding(blok, '');
        return;
      }
      if (e.target.closest('[data-nv-kb-toevoegen]')) {
        toevoegen(blok, data);
      }
    });

    blok.addEventListener('change', function (e) {
      if (e.target.matches('[data-nv-kb-select]')) herreken(blok, data);
    });

      document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.variant-option__button-label')) {
        synchroniseerStraks(blok);
      }
    });

    toonRegels(blok, gekozenAantal(blok));
    herreken(blok, data);
    synchroniseerStraks(blok);
  }

  function start() {
    var blokken = document.querySelectorAll('[data-nv-kleurbundel]');
    for (var i = 0; i < blokken.length; i++) koppel(blokken[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
